import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormTerritory, { TerritoryForm } from 'system/geographic/components/territory/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonTerritoryCrumbs } from '../constants';
import { toast } from 'react-toastify';

const TerritoryNewPage = (): React.ReactElement => {
  const { post: insertTerritory } = useHttpFetch(`${__MUNICIPALITY_API_URL__}/geo/territorio`);

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: TerritoryForm | undefined) => {
      insertTerritory({
        endonimo: formValues?.endonym,
        esonimo: formValues?.exonym,
        flagIntesa: formValues?.electoralAgreement ? 'S' : 'N',
        codiceStato: formValues?.state,
        codiceContinente: formValues?.continent,
        key: {
          codice: formValues?.code,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/estero/territorio');
      });
    },
    [insertTerritory, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonTerritoryCrumbs, { name: 'Nuovo Territorio' }]} />
      <FormTerritory
        title="Nuovo Territorio"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/sistema/geografiche/estero/territorio');
        }}
      />
    </Fragment>
  );
};

TerritoryNewPage.displayName = 'Territory new page component';

export default TerritoryNewPage;
